// M8.1 Agent home / login briefing surface — flag parser.
//
// Env var: VITE_HOME_V2_ENABLED. Default OFF.
// Parser strictly `=== 'true'` per 2026-10-30 M7/M8 amendment §4
// per-surface flag contract. Anything else (undefined, 'false',
// 'TRUE', '1', 'yes', '') stays OFF — the strict comparison is the
// hard contract so a misconfigured env can't accidentally expose
// the new agent home.
//
// Flag OFF: `/v2/home` route is NOT registered in App.tsx. The
//           catch-all RootRedirect sends an authenticated session to
//           /home (legacy) and an unauthenticated session to /landing.
//           Legacy `/home` + any briefing-adjacent routes render their
//           shipped pages byte-identical to pre-PR trunk.
// Flag ON:  `/v2/home` renders the three-section agent home
//           (Briefing + Active Plan Context + Agent Starters).
//           Legacy `/home` STAYS mounted — coexistence, not
//           replacement. Removal is a separate cleanup PR after
//           staging burn-in.

export function isHomeV2Enabled(): boolean {
  return import.meta.env.VITE_HOME_V2_ENABLED === 'true';
}
